<div class="audio-container">
  <audio #audioPlayer [controls]="true"></audio>
  <div class="meta">
    @if (hlsSupported() && !isSafari()) {
      <app-audio-volume-indicator [audioPlayer]="audioPlayer"></app-audio-volume-indicator>
      <div class="name">
        {{ asset().name }}
      </div>
      <div class="info">
        <div class="size">
          {{ versionSize() | dataUnitsBigInt }}
        </div>

        @if (allowDownload()) {
          <span>・</span>

          <app-asset-download-button
            location="audio-viewer"
            [asset]="asset()"
            [gallery]="gallery()"
            [galleryPermissions]="gallery().permissions"
          >
            Download
          </app-asset-download-button>
        }
      </div>
    } @else {
      <app-non-preview-file
        [asset]="asset()"
        [gallery]="gallery()"
        [showSizeAndDownload]="true"
        [showFilename]="true"
        [darkBackground]="true"
        [showBorder]="false"
      ></app-non-preview-file>
    }
  </div>

  @if (showControls()) {
    <div
      class="timeline dont-hide-controls"
      (pointerdown)="mousedown($event)"
      (pointermove)="mousemove($event)"
      (touchmove)="touchTimelineInteraction($event)"
      (touchstart)="touchTimelineInteraction($event)"
      (pointerleave)="currentHoverPosition.set(null); mouseDownOnTimeline.set(false)"
      (pointerup)="currentHoverPosition.set(null); mouseDownOnTimeline.set(false)"
      [class.mousedown]="mouseDownOnTimeline()"
      [@timeline]
    >
      @if (currentHoverPosition() !== null) {
        <div class="current-hover-indicator" [style.left]="currentHoverPosition() + 'px'"></div>
      }

      <div class="timeline-inner" [style.--progress-width]="getProcessingPieceWidth() + '%'">
        <div class="buffer-pieces">
          @for (buffer of buffered(); track buffer.start) {
            <div [style.width]="buffer.end - buffer.start + '%'" [style.left]="buffer.start + '%'" class="buffer"></div>
          }
        </div>

        <div class="processing-piece"></div>
        <div class="past-played" #pastPlayed [style.width]="getPastPlayedWidth() + '%'"></div>
      </div>
    </div>
    <div class="controls-container">
      <div class="audio-controls dont-hide-controls" [@controls]>
        <button
          (click)="playPauseClick($event)"
          ignore-touch-ui-toggle="true"
          appButton
          [name]="audioPlayer.paused ? 'play' : 'paused'"
          location="audio-viewer"
          [iconButton]="true"
          height="1"
          color="hard-simple"
          shape="round"
          [appTooltip]="audioPlayer.paused ? 'Play' : 'Pause'"
          [tooltipKeyboardShortcut]="'SPACE'"
          [toolTipOrigin]="'top-left'"
        >
          @if (audioPlayer.paused) {
            <app-svg src="/assets/icons/play.svg" color="white"></app-svg>
          } @else {
            <app-svg src="/assets/icons/pause.svg" color="white"></app-svg>
          }
        </button>
        <div class="volume-container">
          <button
            (click)="toggleMute()"
            [appTooltip]="muted() ? 'Unmute' : 'Mute'"
            [tooltipKeyboardShortcut]="'M'"
            class="volume-button"
            appButton
            [name]="muted() ? 'unmute' : 'mute'"
            location="audio-viewer"
            [iconButton]="true"
            height="1"
            color="hard-simple"
            shape="round"
          >
            @if (muted()) {
              <app-svg src="/assets/icons/volume-mute.svg" color="white"></app-svg>
            } @else {
              @if (volume() < 0.5) {
                <app-svg src="/assets/icons/volume-low.svg" color="white"></app-svg>
              } @else {
                <app-svg src="/assets/icons/volume-full.svg" color="white"></app-svg>
              }
            }
          </button>
          <div class="volume-slider">
            <input type="range" min="0" max="1" step="0.01" [(ngModel)]="volume" (input)="adjustVolume()" />
            <label [style.--volume-slider-value]="volume() * 100 + '%'"></label>
          </div>
        </div>
        <div class="spacer"></div>
        <app-context-menu [options]="{ width: '240px', noSpacing: true }" #speedMenu>
          <button
            appButton
            name="speed"
            location="audio-viewer"
            [iconButton]="true"
            height="1"
            color="hard-simple"
            shape="round"
            [appTooltip]="'Playback Speed'"
            contextButton
          >
            <app-svg src="/assets/icons/play-speed-{{ speed() }}.svg" color="white"></app-svg>
          </button>
          <div contextContent class="button-menu dont-hide-controls">
            <h3 class="menu-list-title">SPEED</h3>
            @for (_speed of speeds; track _speed) {
              <button
                appButton
                name="speed-adjust"
                location="audio-viewer"
                (click)="adjustSpeed(_speed); speedMenu.close()"
                [color]="speed() === _speed ? 'simple-primary' : 'simple'"
                spacing="full"
              >
                <div class="check-button">
                  <span>
                    @if (_speed !== 1) {
                      {{ _speed | number: '1.1-1' }}x
                    } @else {
                      Normal
                    }
                  </span>
                  @if (_speed === speed()) {
                    <app-svg src="/assets/icons/check.svg" post class="some-check"></app-svg>
                  }
                </div>
              </button>
            }
          </div>
        </app-context-menu>
      </div>
    </div>
  }
</div>
